module.exports = __webpack_public_path__ + "static/media/truck-bg.a7c719f8.webp";